import { render, staticRenderFns } from "./UploaderFlow.vue?vue&type=template&id=9667565a&scoped=true&"
import script from "./UploaderFlow.vue?vue&type=script&lang=js&"
export * from "./UploaderFlow.vue?vue&type=script&lang=js&"
import style0 from "./UploaderFlow.vue?vue&type=style&index=0&id=9667565a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9667565a",
  null
  
)

export default component.exports